/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import WFUIBridgeRecord from '../../records/WFUIBridgeRecord';
import { WFUI_BRIDGE_LOAD, WFUI_BRIDGE_SET_LOADED } from './actions';
var initialState = new WFUIBridgeRecord();

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case WFUI_BRIDGE_LOAD:
      return state.merge({
        load: true
      });

    case WFUI_BRIDGE_SET_LOADED:
      return state.merge({
        loaded: true
      });

    default:
      return state;
  }
}

export default reducer;